/* eslint-disable max-classes-per-file */
export function formatFetchErrors(error) {
  if (typeof error === 'object') {
    if (error.msgFixed) {
      return error;
    }
    // Server replied, but with !OK
    if (error.fromHandler) {
      // fromHandler: true, data: text, res: response
      return {
        message: `Getting error from server: [${error.res.status}], ${
          error.data
        }`,
        msgFixed: true
      };
    }
    // Fetch didn't reach the server
    return {
      message: `Can't access the server: ${error.message}`,
      msgFixed: true
    };
  }
  return { msgFixed: true, errorMsg: error };
}

export class ExelotError extends Error {}

export class UpdateError extends ExelotError {
  constructor() {
    super('שגיאה בעדכון נתוני המשתמש');
  }
}

export class CollectPaymentError extends ExelotError {
  constructor() {
    super('שגיאה בשיחת איסוף');
  }
}
